import React from 'react';
import { Stack, Text, Link } from '@chakra-ui/react';
import Layout from '../../components/Layout';
import ContentWithStickySidebar from '../../components/shared/ContentWithStickySidebar';
import HeroWithBackgroundImage from '../../components/shared/HeroWithBackgroundImage';
import CookiesInformationItems from './CookiesInformationItems';
import HeroImage from '../../images/TrustLPHeader.webp';

const CookiePolicy = () => (
  <Layout title="Cookie Policy">
    <HeroWithBackgroundImage
      imageUrl={HeroImage}
      backgroundColor="'rgba(255,255,255,.55)'"
      title="Cookie Policy"
    />
    <ContentWithStickySidebar>
      <Stack spacing="3">
        <Text>
          We use cookies and other similar technologies (collectively in this
          Policy, “cookies”), in order to provide a better service to you, to
          help keep your account safe, and to generally improve the HOVER
          service. Cookies are small pieces of text used to store information on
          web browsers. They are used by many websites to store and receive
          identifiers and other information on devices, such as a handheld phone
          or computer. You can learn more about cookies and their functions
          generally by visiting an information website such as{' '}
          <Link href="https://allaboutcookies.org">allaboutcookies.org</Link>.
        </Text>
        <Text>
          We also may include tracking pixels, which are small graphic images,
          in our marketing communications to determine engagement. These cookies
          may be set by us or by third parties with whom we have partnered to
          assist in our marketing efforts.
        </Text>
        <Text>
          We use four categories to define the usage of cookies within the HOVER
          service: Functional, Analytical, Advertising, and Social Media.
        </Text>

        <CookiesInformationItems />
      </Stack>
    </ContentWithStickySidebar>
  </Layout>
);

export default CookiePolicy;
